import { gql } from "@apollo/client";

export const REWARD_STORE_ITEM_FRAGMENT = gql`
  fragment RewardStoreItemFragment on RewardStoreItemObject {
    id
    pk
    isLowStock
    hasStock
    isNew
    isCollected
    product {
      id
      slug
      coverPhotoMedium
      coverPhotoSmallPng
      name
      sellingPrice
      pointCost
      characteristics {
        name
      }
      unlockedAtLevel {
        rank
      }
      freebie {
        winefreebie {
          coverPhotoBackgroundColor
        }
      }
    }
  }
`;

export const GET_ALL_REWARD_ITEMS = gql`
  query RewardStore(
    $canBePurchasedWithCash: Boolean
    $isRedeemableWithPoints: Boolean
    $orderBy: String
    $minPoints: Int
    $maxPoints: Int
    $colourIds: [Int]
  ) {
    allRewardStoreItems(
      product_CanBePurchasedWithCash: $canBePurchasedWithCash
      product_IsRedeemableWithPoints: $isRedeemableWithPoints
      orderBy: $orderBy
      product_PointCost_Gte: $minPoints
      product_PointCost_Lte: $maxPoints
      colourIds: $colourIds
    ) {
      edges {
        node {
          ...RewardStoreItemFragment
        }
      }
    }
  }
  ${REWARD_STORE_ITEM_FRAGMENT}
`;

export const GET_REWARD_COLLECTIONS = gql`
  query RewardCollections {
    rewardCollections(excludeEmptyCollections: true) {
      id
      name
      slug
      description
      itemCount
      items(limit: 8) {
        ...RewardStoreItemFragment
        product {
          isRedeemableWithPoints
        }
      }
    }
  }
  ${REWARD_STORE_ITEM_FRAGMENT}
`;

export const GET_REWARD_COLLECTION = gql`
  query RewardCollection($slug: String!, $orderBy: RewardStoreItemOrderField) {
    rewardCollectionBySlug(slug: $slug) {
      id
      name
      slug
      description
      items(orderBy: $orderBy) {
        ...RewardStoreItemFragment
        product {
          isRedeemableWithPoints
        }
      }
    }
  }
  ${REWARD_STORE_ITEM_FRAGMENT}
`;

export const GET_REWARD_FILTERS = gql`
  query RewardFilters {
    allFreebieColours {
      id
      name
    }
  }
`;

export const ADD_REWARD_TO_CART = gql`
  mutation AddRewardToCart($input: AddShoppingCartItemInput!) {
    addShoppingCartItem(input: $input) {
      errors {
        messages
      }
      shoppingCart {
        id
        totalNonSubscriptionProductsCost
        amountPresents
        bottlesTowardsOrderMinimum
        shoppingcartitemSet {
          quantity
          product {
            id
            hasStock
            name
          }
        }
      }
    }
  }
`;

export const ADD_REWARD_TO_BOX = gql`
  mutation AddRewardToBox($productId: Int!, $quantity: Int!, $redeemWithPoints: Boolean!) {
    addProductToNextBox(productId: $productId, quantity: $quantity, redeemWithPoints: $redeemWithPoints) {
      errors {
        messages
      }
      subscription {
        id
        amountPresents
        bottlesTowardsOrderMinimum
        subscriptionnextboxproductSet {
          id
          quantity
          isRedeemedWithPoints
          product {
            id
            name
            slug
            sellingPrice
            pointCost
            coverPhotoSmall
            hasStock
          }
        }
      }
    }
  }
`;

export const REWARD_PRODUCT_FRAGMENT = gql`
  fragment RewardProductFragment on ProductObject {
    id
    name
    hasStock
    coverPhotoMedium
    sellingPrice
    pointCost
    canBePurchasedWithCash
    isRedeemableWithPoints
    descriptionMarkdown
    characteristics {
      name
      id
      values {
        name
        id
      }
    }
    parentProduct {
      id
    }
    variants {
      id
      name
      hasStock
      isLowStock
      productCharacteristicValues {
        id
        productCharacteristic {
          id
        }
      }
    }
    unlockedAtLevel {
      rank
    }
    productType {
      id
    }
    productPhotos {
      id
      photoLarge
    }
    freebie {
      winefreebie {
        coverPhotoBackgroundColor
      }
    }
  }
`;

export const GET_PRODUCT_ITEM_BY_ID = gql`
  query ProductItemById($id: Int!) {
    productById(id: $id) {
      ...RewardProductFragment
    }
  }
  ${REWARD_PRODUCT_FRAGMENT}
`;

export const GET_REWARD_PRODUCT_ITEM_BY_SLUG = gql`
  query RewardProductItemBySlug($slug: String!) {
    productBySlug(slug: $slug) {
      ...RewardProductFragment
    }
  }
  ${REWARD_PRODUCT_FRAGMENT}
`;

export const REDEEM_REWARDS_CODE = gql`
  mutation RedeemRewardsCode($input: RedeemRewardsCodeInput!) {
    redeemRewardsCode(input: $input) {
      isSuccessful
      pointsAwarded
      message
      errors {
        field
        messages
      }
    }
  }
`;
